import Phaser from 'phaser';

export class LevelCompleteScene extends Phaser.Scene {
    constructor() {
        super({ key: 'LevelCompleteScene' });
    }

    create() {
        this.add.text(this.cameras.main.width / 2, this.cameras.main.height / 2, 'Level Complete', { fontSize: '64px', color: '#ffffff' }).setOrigin(0.5);
    }
}
